import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Container } from '@material-ui/core';
import Page from 'src/components/Page';
import Header from 'src/components/Header';
import { useTranslation } from 'react-i18next';
import MaterialStatusManaging from './MaterialStatusManaging';
import BottomRouters from 'src/components/BottomRouters';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  }
}));

function MalzemeIhtiyac() {
  const classes = useStyles();
  const { t } = useTranslation('material_requirement');

  return (
    <Page className={classes.root} title={'Sirius Tech'}>
      <Container maxWidth="lg">
        <Header title= {t('lblPartsDeliveryTitle')}/>
        <MaterialStatusManaging title={t('lblPartsDelivery')} className={classes.todos} />
      </Container>
      <BottomRouters/>
    </Page>
  );
}

export default MalzemeIhtiyac;
